import React from "react";

type Props = {
  drawerOpen: boolean;
  active: string;
  setActive: (val: "matrix" | "daraja") => void;
};

const SideNav: React.FC<Props> = ({ drawerOpen, active, setActive }) => {
  return (
    <aside
      className={`fixed left-0 top-14 h-[calc(100vh-56px)] border-r z-[900] transition-all duration-500 bg-white border-gray-200 ${
        drawerOpen ? "w-[260px]" : "w-[64px]"
      }`}
    >
      <nav className="mt-2 px-2 space-y-1">
        <div
          onClick={() => setActive("daraja")}
          className={`flex items-center cursor-pointer rounded-md text-sm font-medium transition-all ${
            drawerOpen ? "gap-3 px-3 py-2" : "justify-center h-10"
          } ${
            active === "daraja" ? "bg-[#fff4ec] text-orange-600" : "text-gray-700 hover:bg-gray-100"
          }`}
        >
          <span>▦</span>
          {drawerOpen && <span>Daraja Onboarding</span>}
        </div>

        <div
          onClick={() => setActive("matrix")}
          className={`flex items-center cursor-pointer rounded-md text-sm font-medium transition-all ${
            drawerOpen ? "gap-3 px-3 py-2" : "justify-center h-10"
          } ${
            active === "matrix" ? "bg-[#fff4ec] text-orange-600" : "text-gray-700 hover:bg-gray-100"
          }`}
        >
          <span>▤</span>
          {drawerOpen && <span>Access Matrix</span>}
        </div>

           <div
          onClick={() => setActive("widget")}
          className={`flex items-center cursor-pointer rounded-md text-sm font-medium transition-all ${
            drawerOpen ? "gap-3 px-3 py-2" : "justify-center h-10"
          } ${
            active === "widget" ? "bg-[#fff4ec] text-orange-600" : "text-gray-700 hover:bg-gray-100"
          }`}
        >
          <span>▤</span>
          {drawerOpen && <span>Widget Configuration</span>}
        </div>

        <div
          onClick={() => setActive("common")}
          className={`flex items-center cursor-pointer rounded-md text-sm font-medium transition-all ${
            drawerOpen ? "gap-3 px-3 py-2" : "justify-center h-10"
          } ${
            active === "common" ? "bg-[#fff4ec] text-orange-600" : "text-gray-700 hover:bg-gray-100"
          }`}
        >
          <span>▤</span>
          {drawerOpen && <span>Common Configuration</span>}
        </div>
         <div
          onClick={() => setActive("user")}
          className={`flex items-center cursor-pointer rounded-md text-sm font-medium transition-all ${
            drawerOpen ? "gap-3 px-3 py-2" : "justify-center h-10"
          } ${
            active === "user" ? "bg-[#fff4ec] text-orange-600" : "text-gray-700 hover:bg-gray-100"
          }`}
        >
          <span>▤</span>
          {drawerOpen && <span>User Eligibility</span>}
        </div>
      </nav>
    </aside>
  );
};

export default SideNav;
